import * as type from '../../../actions/index.types'

export function SocietyReducers(state = {
    loading: false,
    countriesLoading: false,
    statesLoading: false,
    citiesLoading: false,
    countriesData: null,
    statesData: null,
    citiesData: null,
    error: null
}, action) {

    switch (action.type) {
        // Get Countries
        case type.SOCIETY_GET_COUNTRIES:
            return {
                ...state,
                countriesLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_COUNTRIES_SUCCESS: {
            return {
                ...state,
                error: null,
                countriesLoading: false,
                countriesData: action.payload,
            }
        }
        case type.SOCIETY_GET_COUNTRIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                countriesLoading: false,
            }

        // Get States
        case type.SOCIETY_GET_STATES:
            return {
                ...state,
                statesLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_STATES_SUCCESS: {
            return {
                ...state,
                error: null,
                statesLoading: false,
                statesData: action.payload,
            }
        }
        case type.SOCIETY_GET_STATES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                statesLoading: false,
            }

        // Get Cities
        case type.SOCIETY_GET_CITIES:
            return {
                ...state,
                citiesLoading: true,
                error: null,
            }
        case type.SOCIETY_GET_CITIES_SUCCESS: {
            return {
                ...state,
                error: null,
                citiesLoading: false,
                citiesData: action.payload,
            }
        }
        case type.SOCIETY_GET_CITIES_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                citiesLoading: false,
            }

        default:
            return state
    }
}
